import { get, post } from "../../../../services/request";

export const getAllStateLicense = () => {
  return get("StateLicense/GetAllStateLicense");
};

export const getStateLicenseNotesByDetailsId = (payload) => {
  return get(`StateLicense/GetStateLicenseNotesByDetailsId/${payload.stateLicenseDetailsId}`);
};

export const addStateLicenseNote = (payload) => {
  return post("StateLicense/AddStateLicenseNote", payload);
};
